// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sharing-entry[data-v-7cbe9523]{display:flex;align-items:center;height:44px}.sharing-entry__desc[data-v-7cbe9523]{display:flex;flex-direction:column;justify-content:space-between;padding:8px;line-height:1.2em}.sharing-entry__desc p[data-v-7cbe9523]{color:var(--color-text-maxcontrast)}.sharing-entry__actions[data-v-7cbe9523]{margin-left:auto}\n", ""]);
// Exports
module.exports = exports;
